/**
 * A small square client avatar with initials, used in triage rows, the
 * detail pane bar and agenda rows. Sized in pixels to match the design.
 */
import type { FC } from "react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { initialsFrom } from "@/features/globalSearch/searchModel";
import { cn } from "@/lib/utils";

type Props = {
  name: string;
  /** Edge length in px (14, 18, 20…). */
  size?: number;
  className?: string;
};

export const ClientAvatar: FC<Props> = ({ name, size = 16, className }) => (
  <Avatar
    shape="square"
    title={name}
    data-testid="client-avatar"
    className={cn("shrink-0 rounded-xs", className)}
    style={{ width: size, height: size }}
  >
    <AvatarFallback
      className="bg-muted font-medium text-fg-2"
      style={{ fontSize: Math.max(7, Math.round(size * 0.45)) }}
    >
      {initialsFrom(name) || "?"}
    </AvatarFallback>
  </Avatar>
);
